export default "__VITE_ASSET__BWK3QLhQ__"